export default "__VITE_ASSET__gHmPVPrW__"